import React from "react";
import { useParams } from "react-router-dom";

import { Loader } from "../../shared";
import SubscriptionComparison from "../../shared/subscription-comparison/SubscriptionComparison";
import { SupportFooter } from "../../shared/support-footer/SupportFooter";
import NotFound from "../not-found/NotFound";
import { title } from "./placeholderSubscriptionComparisonData";

import "./choose-subscription-page.scss";
import { useComparableSubscriptions } from "./useComparableSubscriptions.ts";
import MinSideBanner from "~/components/header/MinSideBanner.tsx";

type ParamTypes = {
  partnerAlias?: string;
  dwellingUnit?: string;
};

export const ChooseSubscriptionPage: React.FC<Partial<ParamTypes>> = (
  props,
) => {
  const params = useParams<ParamTypes>();
  // we know params are defined here since they are part of the route, default values are for typescript only
  const partnerAlias = props.partnerAlias || params.partnerAlias || "";
  const dwellingUnit = props.dwellingUnit || params.dwellingUnit || "";

  const { data, isLoading, error } = useComparableSubscriptions(
    partnerAlias,
    dwellingUnit,
  );

  if (error) {
    return <NotFound />;
  }
  if (isLoading || !data) {
    return <Loader />;
  }

  return (
    <>
      <main className="choose-subscription-page main-layout container padded wide">
        <MinSideBanner />
        <SubscriptionComparison
          title={title}
          comparableSubscriptions={data}
          partnerAlias={partnerAlias}
          dwellingUnit={dwellingUnit}
        />
      </main>
      <SupportFooter />
    </>
  );
};
